import { render, staticRenderFns } from "./EmailQuestion.vue?vue&type=template&id=95ce3dd2"
import script from "./EmailQuestion.vue?vue&type=script&lang=js"
export * from "./EmailQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports